module.exports = __webpack_public_path__ + "img/avatar.1f52ba21.png";